import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function UserGuard({ children }) {
  const { user, admin } = useAuth();
  const location = useLocation();
  if (user === undefined || admin === undefined) return <LoadingShell />;
  // If the app is running as an INSTALLED PWA (standalone display-mode) and only
  // an admin token exists (no user token), the icon was almost certainly added
  // from the admin panel — send them back to /admin. In a normal browser tab we
  // still show user signup so `rtec.co.in/` is safe for regular visitors.
  if (!user && admin) {
    const isStandalone =
      (typeof window !== "undefined") &&
      (window.matchMedia?.("(display-mode: standalone)").matches ||
        window.navigator.standalone === true);
    if (isStandalone) return <Navigate to="/admin" replace />;
  }
  if (!user) return <Navigate to="/register" replace state={{ from: location }} />;
  return children;
}

export function AdminGuard({ children }) {
  const { admin } = useAuth();
  const location = useLocation();
  if (admin === undefined) return <LoadingShell />;
  if (!admin) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
}

function LoadingShell() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="text-2xl font-display font-bold text-yellow-500 tracking-tight">J&amp;K CLUB</div>
        <div className="text-xs uppercase tracking-widest text-slate-400 mt-2">Loading…</div>
      </div>
    </div>
  );
}
